import React, { useEffect, useState } from 'react';
import { Link, useFetcher, useNavigate } from "react-router-dom";


import { useDispatch, useSelector } from "react-redux";

export default function Button(props) {

    const { 
        className, 
        onPress=()=>{},
        type,
        styles,
        disabled,
        buttonTxt,
        titleimgs="",
        id_data="",
        filenames=""
    } = props;


    const dispatch = useDispatch();
    const navigate = useNavigate();

    
    return (
        <>
            <button 
                id={id_data} 
                filenamedata={filenames} 
                style={styles} 
                className={`${className ? className : 'normalbutton'} ${disabled === true && 'buttondisabled'}`} 
                onClick={onPress} 
                type={type} 
            >
                {titleimgs !== '' && <img src={titleimgs} />}
                {buttonTxt}
            </button>
        </>
    )    
}